import { styled } from '@mui/material/styles';
import { Box, Typography, IconButton, Tabs, Tab, Grid, TextField, Paper } from '@mui/material';

// Drawer Header Styles
export const HeaderTypography = styled(Typography)(({ theme }) => ({
  variant: 'h6'
}));

// Container Styles
export const MappingContainer = styled(Grid)(({ theme }) => ({
  overflowY: 'scroll',
  padding: theme.spacing(2),
  height: '90vh'
}));

// Paper Styles
export const MappingPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: 'white',
  elevation: 0,
  boxShadow: 'none',
  borderRight: '1px solid #CCCCCC',
  height: '90vh',
  overflowY: 'scroll'
}));

// Typography Styles
export const TitleTypography = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '30px',
  letterSpacing: '0%'
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px',
  letterSpacing: '0%',
  color: '#555555'
}));

export const HeaderLabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color: '#757575'
}));

export const CategoryTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color: '#FF8C00',
  marginBottom: theme.spacing(1)
}));

export const ProductNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#1A1A1A'
}));

// Tab Styles
export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTab-root': {
    fontWeight: 400,
    fontSize: '14px',
    color: '#757575',
    textTransform: 'none',
    minHeight: '48px',
    padding: '12px 16px',
    '&.Mui-selected': {
      color: '#00A67E',
      fontWeight: 500
    }
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#00A67E'
  }
}));

export const StyledTab = styled(Tab)(({theme}) =>  ({
  '&.Mui-disabled': {
    pointerEvents: 'none',
    color: "#CCCCCC !important",
    '& *': {
      color: "#CCCCCC !important",
      pointerEvents: 'none',
    },
  },
}))

export const TabLabelBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center'
}));

export const TabLabelText = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(0.5)
}));

export const TabCountText = styled(Typography)(({ theme }) => ({
  color: '#757575', 
}));

// Search Field Styles
export const SearchField = styled(TextField)(({ theme }) => ({
  marginLeft: 'auto',
  width: '50%'
}));

// Product List Styles
export const ProductListBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const ProductItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  spacing: theme.spacing(2),
  '&:hover': { bgcolor: 'action.hover' },
  cursor: 'pointer'
}));

export const ProductInfoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center'
}));

export const ProductPriceTypography = styled(Typography)(({ theme }) => ({
  color: 'primary.main'
}));

// Add Ons Styles
export const AddOnsContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const AddOnItemGrid = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  borderBottom: '1px solid #EAEAEA'
}));

export const AddOnNameContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center'
}));